import { render, staticRenderFns } from "./ChannelPartnerCustomerList.vue?vue&type=template&id=133e5db4&scoped=true"
import script from "./ChannelPartnerCustomerList.vue?vue&type=script&lang=js"
export * from "./ChannelPartnerCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e5db4",
  null
  
)

export default component.exports